import {keccak256, hashMessage, recoverAddress, recoverPublicKey, solidityKeccak256, verifyMessage} from "ethers/utils";

import Identity from './lib/Identity.class';
import Config from './lib/Config';
import {KeyPurpose, KeyType} from "./lib/Key.interface";
import {AccessGrantStatus, AccessGrantType, ClaimScheme, ClaimType} from "./lib/Claim.interface";
import {Claim} from "./lib/Claim.class";
import Utils from "./lib/Utils";
import { ErrorNotificationEmitter } from "./lib/core/events/ErrorNotification.emitter";
import * as ERC725 from "./resources/contracts/ERC725.json";
import * as ERC735 from "./resources/contracts/ERC735.json";
import Providers from "./lib/Providers";

export = {
  Config,
  Identity,
  Claim,
  Providers,
  Events: {
    ErrorNotification: ErrorNotificationEmitter,
  },
  utils: {
    enums: {
      ClaimScheme,
      ClaimType,
      KeyPurpose,
      KeyType,
      AccessGrantType,
      AccessGrantStatus,
    },
    contracts: {
      ERC725,
      ERC735,
    },
    crypto: {
      keccak256,
      hashMessage,
      recoverAddress,
      recoverPublicKey,
      solidityKeccak256,
      verifyMessage,
    },
    ...Utils,
  },
}
